
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";

import { BaseService } from './base.service';

import { ENVIRONMENT } from '../../environments/environment';

@Injectable()
export class NoteService {
  constructor(
    private baseService: BaseService
  ) {
  }

  // Note
  getRepaymentNotes(loanId: number): Observable<any> {
    let url = ENVIRONMENT.service.note + "/notes/repayments/loan/" + loanId + "?sort=desc";
    return this.baseService.get(url);
  }

  getRepaymentsNotes(loanIds: Array<number>): Observable<any> {
    let url = ENVIRONMENT.service.note + "/notes/available/collection_ids?collection_ids=" + loanIds.join(',') + "&note_type=REPAYMENT";
    return this.baseService.get(url);
  }
}
